<template>
    <!-- 新增用户组 -->
    <a-modal
      :title="defaultVal ? '修改用户组' : '新增用户组'"
      :visible="visible"
      :confirmLoading="confirmLoading"

      okText="提交"
      cancelText="取消"
      @ok="handlerSubmit"
      @cancel="() => $emit('hideModal')"

      :afterClose="afterHideEditModal"
    > 
      <a-form-model 
        ref="groupForm"
        :model="groupForm" 
        :rules="groupFormRules"
        :label-col="{ span: 6 }" 
        :wrapper-col="{ span: 18 }" 
      >
        <a-form-model-item required label="用户组名称" prop="name">
          <a-input 
            v-model="groupForm.name"
            placeholder="请填写用户组名称"
          />
        </a-form-model-item>
        <a-form-model-item label="用户组描述" prop="description">
          <a-input
            type="textarea"
            v-model="groupForm.description"
            placeholder="请填写用户组描述"
          />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
</template>

<script>
const groupForm = { name: undefined, description: undefined }
const groupFormRules = { name: [{ required: true, message: '请填写用户组名称！' }] }

export default {
  name: 'EditUserGroupModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    defaultVal: {
      type: Object,
      default: () => null
    }
  },
  data () {
    return {
      groupForm,
      groupFormRules,

      confirmLoading: false
    }
  },
  computed: {},
  watch: {
    defaultVal: function(data) {
      this.$nextTick(() => {
        if (data && this.visible) this.groupForm = { ...data }
      })
    }
  },
  methods: {
    // 提交模态框数据
    handlerSubmit() {
      this.$refs.groupForm.validate(async valid => {
        if (valid) {
          if (this.defaultVal) {
            const { name: n, description: desc } = this.defaultVal
            const { name: newN, description: newDesc } = this.groupForm
            if (n === newN && desc === newDesc) {
              this.$emit('hideModal')
              return
            }
          }

          this.$emit('submit', this.groupForm)
          this.confirmLoading = true
        }
      })
    },
    // 编辑用户组模态框关闭后，重置相关数据
    afterHideEditModal() {
      this.$refs.groupForm.resetFields()
      this.groupForm = groupForm
      this.confirmLoading = false
    }
  }
}
</script>

<style>
</style>
